<template>
  <div class="view">

		<box :label=" projects_without_timeline.length + ' projekter uden start/slut-dato'" v-if="myUser.email=='wp@milk-studio.dk' || myUser.email=='db@milk-studio.dk'">
			<template v-for="(project,project_i) in projects_without_timeline">
				<btn @click.native="goto('project/'+project['.key'])">{{project.name}}</btn> &nbsp;
			</template>
		</box>

		<box :label=" projects_without_budget.length + ' Projekter uden budget'" v-if="myUser.email=='wp@milk-studio.dk' || myUser.email=='db@milk-studio.dk'">
			<template v-for="(project,project_i) in projects_without_budget">
				<btn @click.native="goto('project/'+project['.key'])">{{project.name}}</btn> &nbsp;
			</template>
		</box>

		<box :label="active_projects_beyond_end_date.length + ' Afsluttede projekter?'" v-if="myUser.email=='wp@milk-studio.dk' || myUser.email=='db@milk-studio.dk'">
			<template v-for="(project,project_i) in active_projects_beyond_end_date">
				<btn @click.native="goto('project/'+project['.key'])">{{project.name}}</btn> &nbsp;
			</template>
		</box>

  </div>
</template>

<script>
import mixins from '../mixins.js';
import helpers from '../helpers.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Avatar from '.././components/Avatar'
export default {
  name: 'clients',
  mixins: [ mixins.db, mixins.generic ],
  components: { Box, Btn, Avatar },
  data: function () {
    return {
      
    }
  },
  computed:{

		active_projects_beyond_end_date(){ return this.$store.getters['projects/active_projects_beyond_end_date'] },
		projects_without_timeline(){ return this.$store.getters['projects/projects_without_timeline'] },
		projects_without_budget(){ return this.$store.getters['projects/projects_without_budget'] },

		myUser(){ return this.$store.getters['users/my_user'] },

  },//computed
  methods: {	
		
	},
}
</script>



// WEBPACK FOOTER //
// Report_missing_input.vue?75bdad84